import { render, staticRenderFns } from "./BaseTooltipV2.vue?vue&type=template&id=a7390dc8&scoped=true"
import script from "./BaseTooltipV2.vue?vue&type=script&lang=js"
export * from "./BaseTooltipV2.vue?vue&type=script&lang=js"
import style0 from "./BaseTooltipV2.vue?vue&type=style&index=0&id=a7390dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7390dc8",
  null
  
)

export default component.exports